export default (url) =>
  url.startsWith("/") || url.startsWith("http") ? url : `/${url}`;
